// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CanonicalAddress,
} from "./types";


export default __t.row({
  id: __t.string(),
  googlePlaceId: __t.string().name("google_place_id"),
  name: __t.option(__t.string()),
  businessType: __t.option(__t.string()).name("business_type"),
  heroCdnPath: __t.option(__t.string()).name("hero_cdn_path"),
  colorPrimary: __t.option(__t.string()).name("color_primary"),
  colorText: __t.option(__t.string()).name("color_text"),
  get canonicalAddress() {
    return __t.option(CanonicalAddress).name("canonical_address");
  },
  nominatedByDisplayName: __t.option(__t.string()).name("nominated_by_display_name"),
  isClaimed: __t.bool().name("is_claimed"),
  totalInterested: __t.u32().name("total_interested"),
  totalInterestDollars: __t.option(__t.u32()).name("total_interest_dollars"),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  createdAt: __t.timestamp().name("created_at"),
});
